import { HttpContextToken } from '@angular/common/http';

/** When true, 404s still toast but rethrow so callers (e.g. rxResource) can show retry UI. */
export const PROPAGATE_404 = new HttpContextToken<boolean>(() => false);
